<template>
  <div style="width: 100%; min-height: 100vh; background: rgb(237, 241, 255)">
    <van-nav-bar style="position: fixed; top: 0; left: 0; width: 100%; background-color: #f7f8fa" title="生日礼金" left-arrow @click-left="$router.back()" />
    <div style="height: 46px"></div>

    <!-- 顶部：生日 + 待领 + 累计 + 一键领取 -->
    <div style="width: 95%; min-width: 250px; margin: 10px auto 0; background: #fff; border-radius: 10px; box-sizing: border-box; padding: 14px">
      <div style="display: flex; align-items: center; justify-content: space-between">
        <span style="font-size: 0.3rem" v-if="myBirthday">我的生日：<strong style="color: #8a1a34">{{ myBirthday }}</strong></span>
        <span style="font-size: 0.3rem; color: #ff976a" v-else>未设置生日</span>
        <van-button v-if="myBirthday" style="width: 3rem; height: 0.68rem; min-width: 80px" type="info" :loading="claiming" @click="claim"><span style="color: #fff; font-size: 0.3rem">一键领取</span></van-button>
        <van-button v-else style="width: 3rem; height: 0.68rem; min-width: 80px" type="warning" @click="$parent.goNav('/userInfo')"><span style="color: #fff; font-size: 0.3rem">去设置生日</span></van-button>
      </div>
      <div style="display: flex; box-sizing: border-box; padding: 12px 0 2px; justify-content: space-between; align-items: center">
        <div style="text-align: center; width: 49%">
          <div style="font-size: 0.28rem; color: #888">累计已领</div>
          <div style="font-size: 0.34rem; color: #8a1a34; font-weight: 700">￥{{ bdClaimed }}</div>
        </div>
        <div style="height: 0.6rem; border-left: 1px solid #f1f1f1"></div>
        <div style="text-align: center; width: 49%">
          <div style="font-size: 0.28rem; color: #888">待领取</div>
          <div style="font-size: 0.34rem; color: #8a1a34; font-weight: 700">￥{{ bdPending }}</div>
        </div>
      </div>
    </div>

    <!-- 阶梯表 -->
    <div style="width: 95%; min-width: 250px; margin: 10px auto 0; background: #fff; border-radius: 10px; box-sizing: border-box; padding: 14px">
      <div style="font-size: 0.3rem; font-weight: 700; margin-bottom: 8px">各等级生日礼金</div>
      <div style="display: flex; align-items: center; height: 0.8rem; border-bottom: 1px solid #f4f4f4; font-size: 0.28rem; color: #999">
        <div style="width: 50%">VIP等级</div>
        <div style="width: 50%; text-align: right">生日礼金(元)</div>
      </div>
      <div v-for="(t, i) in tiers" :key="i" style="display: flex; align-items: center; height: 0.82rem; border-bottom: 1px solid #f7f7f7; font-size: 0.3rem">
        <div style="width: 50%">{{ t.vipname }}</div>
        <div style="width: 50%; text-align: right; color: #8a1a34; font-weight: 600">{{ Number(t.birthday_bonus) }}</div>
      </div>
    </div>

    <!-- 领取记录 -->
    <div style="width: 95%; min-width: 250px; margin: 10px auto 0; background: #fff; border-radius: 10px; box-sizing: border-box; padding: 14px">
      <div style="font-size: 0.3rem; font-weight: 700; margin-bottom: 8px">领取记录</div>
      <div v-if="records.length > 0">
        <div v-for="(r, i) in records" :key="i" style="display: flex; justify-content: space-between; align-items: center; height: 0.82rem; border-bottom: 1px solid #f7f7f7; font-size: 0.28rem">
          <div>
            <div style="color: #333">生日礼金 ￥{{ Number(r.real_money) }}</div>
            <div style="color: #aaa; font-size: 0.24rem">{{ r.created_at }}</div>
          </div>
          <div :style="{ color: r.state == 1 ? '#07c160' : '#ff976a' }">{{ r.state == 1 ? '已领取' : '待领取' }}</div>
        </div>
      </div>
      <div v-else style="text-align: center; padding: 24px 0">
        <img src="/static/image/mescroll-empty.png" style="width: 30%" alt="" />
        <div style="color: #ccc; font-size: 0.26rem; margin-top: 6px">暂无记录</div>
      </div>
    </div>

    <!-- 规则 -->
    <div style="width: 95%; min-width: 250px; margin: 10px auto; background: #fff; border-radius: 10px; box-sizing: border-box; padding: 14px; padding-bottom: 40px">
      <div style="font-size: 0.3rem; font-weight: 700; margin-bottom: 8px">活动规则</div>
      <p style="font-size: 0.26rem; color: #666; line-height: 1.8; margin: 0">
        1、需在个人资料中设置真实生日，生日当天系统自动发放对应等级的生日礼金；<br />
        2、每年可领取一次，礼金金额按当前VIP等级确定；<br />
        3、礼金领取后并入可用余额，提款仍需满足全站有效投注要求；<br />
        4、{{ $store.state.appInfo.title || '本平台' }}保留对本活动的最终解释权。
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'birthdaybonus',
  data() {
    return {
      myBirthday: '',
      bdPending: 0,
      bdClaimed: 0,
      tiers: [],
      records: [],
      claiming: false,
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bonusinfo', {})
        .then(res => {
          that.$parent.hideLoading();
          if (res.code == 200 && res.data) {
            that.myBirthday = res.data.my_birthday || '';
            that.bdPending = Number(res.data.birthday_pending) || 0;
            that.bdClaimed = Number(res.data.birthday_claimed) || 0;
            that.tiers = res.data.tiers || [];
            that.records = res.data.birthday_records || [];
          }
        })
        .catch(() => {
          that.$parent.hideLoading();
        });
    },
    claim() {
      let that = this;
      if (that.claiming) return;
      if (that.bdPending <= 0) {
        that.$parent.showTost(0, '暂无可领取的生日礼金');
        return;
      }
      that.claiming = true;
      that.$apiFun
        .post('/api/dobonus', { type: 8 })
        .then(res => {
          that.claiming = false;
          that.$parent.showTost(res.code == 200 ? 1 : 0, res.message || '');
          if (res.code == 200) {
            that.$parent.getBalance && that.$parent.getBalance();
            that.load();
          }
        })
        .catch(() => {
          that.claiming = false;
          that.$parent.showTost(0, '领取失败，请稍后重试');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/birthdaybonus.vue